import { useZCalendarWebApiHandler_getTourForSatelliteConversationId } from '@zg-rentals/ts-z-calendar-client-react-query';
import type { ListingAlias } from '@zg-rentals/ts-z-calendar-client';

import { ZCALENDAR_TOURS_QUERY_TAG } from '../constants/queryTags';

// The generated client does not export its params interface, and deriving it via
// Parameters<> resolves to a non-exportable type (TS4023 on declaration emit), so it is re-declared here.
type GetTourForSatelliteConversationIdParams = {
  conversationId: string;
  listingAlias: ListingAlias;
};

type Options = {
  /** Names the consuming surface in error logs, e.g. 'TourStatusCard - Error fetching tour'. */
  errorDetails: string;
};

// Fetches the tour for a conversation; tagged so usePerformTourAction invalidates it automatically.
const useTourForSatelliteConversationId = (
  getParams: GetTourForSatelliteConversationIdParams,
  { errorDetails }: Options,
) =>
  useZCalendarWebApiHandler_getTourForSatelliteConversationId(getParams, {
    meta: {
      tags: [ZCALENDAR_TOURS_QUERY_TAG],
      context: {
        api: 'getTourForSatelliteConversationId',
        details: errorDetails,
      },
    },
  });

export default useTourForSatelliteConversationId;
